/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTabQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab.ts";
import { courseRegistrationManagementInstructionsViewModelSchema } from "../courseRegistrationManagementInstructionsViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTabPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab200Schema =
  z.lazy(
    () => courseRegistrationManagementInstructionsViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTabQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTab200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidInstructionsTabQueryResponse>;
